import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { Outlet } from 'react-router-dom';
import useSmartNav from '~/hooks/use-smart-nav';
import DesktopTitledLayout from './desktop-layout';
import MobileLayout from './mobile-layout';

// Wrapper for account-experience pages that are single (non-tabbed) routes
// (Communications, PrePay & Balance). Gives each a desktop title header from
// the per-page NavigationContext title; mobile shows the page bare (the header bar carries
// the title there).
export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { title } = useSmartNav();

  if (isXs) {
    return (
      <MobileLayout>
        <Outlet />
      </MobileLayout>
    );
  }

  return (
    <DesktopTitledLayout title={title}>
      <Outlet />
    </DesktopTitledLayout>
  );
}

Component.displayName = 'My Account Page';
